import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WalletItemCustomerRewardCard } from "../../../store/common";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import { useForm } from "react-hook-form";
import { getFlowByName } from "../../../config/FlowName";
import * as NextStepFlowAction from "../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../store";
import { PATTERNS } from "../../../util/patterns";
import { useTranslation } from "react-i18next";

const CustomerRewardsCardDialog: React.FunctionComponent<{
    requestDataCallback(): void;
    walletItem: WalletItemCustomerRewardCard;
    isNew: boolean;
    closeDialog(): void;
}> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [isLoading, setisLoading] = useState(false);

    const dispatch = useDispatch();
    const lostWalletFlow = useSelector((state: ApplicationState) => getFlowByName(state, "LOST-WALLET-ASSISTANCE"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const [rewardCard, setRewardCard] = useState(props.walletItem);
    const [errorMsg, seterrorMsg] = useState("");
    const [hasError, setHasError] = useState(false);

    /**Validation with react-hook-form ***/
    const { register, errors, formState, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const { isSubmitting } = formState;

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refresWalletItem = () => {
        closeDialog();
        props.requestDataCallback();
    };

    function onChnageHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setRewardCard({ ...rewardCard, [elName as string]: event.currentTarget.value });
    }

    const saveItem = () => {
        const requestBody = {
            "lost-wallet": {
                "lost-wallet-customerreward": rewardCard,
            },
        };
        setisLoading(true);
        httpClient
            .sendRequest("POST", "api/lostWallet/" + (props.isNew ? "addNewWalletItem" : "updateWalletItem"), requestBody)
            .then((data) => {
                setisLoading(false);
                if (data.isSuccess) {
                    if (lostWalletFlow && lostWalletFlow.flowStepStatus !== "COMPLETED") {
                        completeGetStartedItem(lostWalletFlow.flowStepId, lostWalletFlow.flowName ? lostWalletFlow.flowName : " ");
                    }
                    Notification({
                        type: "success",
                        title: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.addToastTitle")
                            : tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.updateToastTitle"),
                        message: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.addToastMessage")
                            : tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.updateToastMessage"),
                    });
                    refresWalletItem();
                } else if (data.hasError && data.errors.length > 0) {
                    seterrorMsg(data.errors.join(", "));
                    setHasError(true);
                } else {
                    seterrorMsg(tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.unknownError"));
                    setHasError(true);
                }
            })
            .catch(function (error) {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.errorToastTitle"),
                    message: tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.errorToastMesage"),
                    duration: 0,
                });
                closeDialog();
            });
    };

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className={props.isNew ? "las la-plus" : "las la-edit"}></em>
                        </div>
                        <h1>
                            {props.isNew
                                ? tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.addLabel")
                                : tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.editLabel")}{" "}
                            {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.title")}
                        </h1>
                    </div>
                    <form onSubmit={handleSubmit(saveItem)} id="reward-card-info-form-container">
                        <div className="dialog-body">
                            <div className={errors["cardName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-card-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.cardName")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-card-name"
                                            aria-labelledby="edit-card-name"
                                            name="cardName"
                                            defaultValue={rewardCard.cardName}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                required: true,
                                            })}
                                            maxLength={50}
                                        />
                                        {errors.cardName && errors.cardName.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.validationMessage.cardName.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["cardNumber"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-card-number">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.cardNumber")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-card-number"
                                            aria-labelledby="edit-card-number"
                                            name="cardNumber"
                                            defaultValue={rewardCard.cardNumber}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                required: true,
                                                pattern: /^[a-zA-Z0-9]+$/,
                                            })}
                                            maxLength={20}
                                        />
                                        {errors.cardNumber && errors.cardNumber.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.validationMessage.cardNumber.required")}
                                            </span>
                                        )}

                                        {errors.cardNumber && errors.cardNumber.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.validationMessage.cardNumber.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["cardHolderName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-card-holder-full-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.cardHolderFullName")}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-card-holder-full-name"
                                            aria-labelledby="edit-card-holder-full-name"
                                            name="cardHolderName"
                                            defaultValue={rewardCard.cardHolderName}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                pattern: PATTERNS.CARDHOLDERNAME.pattern,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.cardHolderName && errors.cardHolderName.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.validationMessage.fullName.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["pin"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-pin">{tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.pin")}</label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-pin"
                                            aria-labelledby="edit-pin"
                                            name="pin"
                                            defaultValue={rewardCard.pin}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                pattern: /^$|^(\d{4})$/,
                                            })}
                                            maxLength={4}
                                        />
                                        {errors.pin && errors.pin.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.validationMessage.pin.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["customerServicePhoneNumber"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-customer-service-phone">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.customerServicePhone")}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-customer-service-phone"
                                            aria-labelledby="edit-customer-service-phone"
                                            name="customerServicePhoneNumber"
                                            defaultValue={rewardCard.customerServicePhoneNumber}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                pattern: /^[01]?[- .]?(\([2-9]\d{2}\)|[2-9]\d{2})[- .]?\d{3}[- .]?\d{4}$/,
                                            })}
                                        />
                                        {errors.customerServicePhoneNumber && errors.customerServicePhoneNumber.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang(
                                                    "identityVault.secureStorage.lostWallterWidget.customerRewardCard.validationMessage.customerServicePhone.pattern"
                                                )}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-website-name">
                                        {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.website")}
                                    </label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-website-name"
                                        aria-labelledby="edit-website-name"
                                        name="webSite"
                                        maxLength={50}
                                        defaultValue={rewardCard.webSite}
                                        onChange={onChnageHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-notes">{tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.notes")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <textarea
                                        className="inputbox"
                                        id="edit-notes"
                                        aria-labelledby="edit-notes"
                                        name="notes"
                                        maxLength={500}
                                        style={{ resize: "none" }}
                                        placeholder=""
                                        rows={6}
                                        defaultValue={rewardCard.notes}
                                        onChange={onChnageHandler}
                                    ></textarea>
                                </div>
                            </div>

                            {hasError && (
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter"></div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <p className="form-error">{errorMsg}</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                        <span className="btn-text">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.cancelButtonText")}
                                        </span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="submit" className="btn-default btn-primary" disabled={isSubmitting}>
                                        <span className="btn-text">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.label.saveButtonText")}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default CustomerRewardsCardDialog;
